// src/api/axiosInstance.ts
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("access_token");

        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401) {
            console.warn("⚠️ Unauthorized — возможно, токен истёк");
        }
        return Promise.reject(error);
    }
);

export const isAuth = () => {
    const token = localStorage.getItem("access_token");
    return !!token;
};

export default api;
